import { render, staticRenderFns } from "./RegisteredSold.vue?vue&type=template&id=5862d600&scoped=true"
import script from "./RegisteredSold.vue?vue&type=script&lang=js"
export * from "./RegisteredSold.vue?vue&type=script&lang=js"
import style0 from "./RegisteredSold.vue?vue&type=style&index=0&id=5862d600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862d600",
  null
  
)

export default component.exports